import xlsxParser from 'xlsx-parse-json';

// eslint-disable-next-line import/prefer-default-export
export const parseJsonFromXLSX = async (file) => {
    try {
        const data = await xlsxParser.onFileSelection(file);
        return data;
    } catch (err) {
        console.log('Error parsing JSON from XLSX file: ', err.message);
        return null;
    }
};
